import { Num, Row } from "./shared";

export const BumpsTab = ({ d, setPart }) => (
  <div
    className="mt-6 rounded-lg border border-zinc-800 bg-zinc-900 p-5"
    data-testid="drawing-bumps"
  >
    <Row label="Default bump-out width">
      <Num
        testId="bumps-width"
        value={d.bumps.width_in}
        onChange={(v) => setPart("bumps", { width_in: v })}
        suffix="in"
      />
    </Row>
    <Row label="Default bump-out depth">
      <Num
        testId="bumps-depth"
        value={d.bumps.depth_in}
        onChange={(v) => setPart("bumps", { depth_in: v })}
        suffix="in"
      />
    </Row>
  </div>
);
